import { check } from './utils';
export default function detectNightElf() {
    return check();
}
